export const translations = {
  it: {
    brand: "Il Genio in Vacanza",
    tagline: "L'itinerario perfetto, evocato in un istante.",
    nav: {
      plan: "Pianifica",
      trips: "I miei viaggi",
      wishes: "Sogni",
      feedback: "Feedback",
      login: "Accedi",
      register: "Registrati",
      logout: "Esci",
    },
    landing: {
      overline: "AI Travel Atelier",
      title: "Esprimi un desiderio. Il tuo viaggio prende forma.",
      subtitle:
        "Racconta al Genio partenza, destinazione, date, persone e budget: intreccia voli, hotel e esperienze in un itinerario giorno per giorno.",
      cta: "Evoca il viaggio",
      cta_login: "Ho già un account",
      feature_1_title: "Itinerari giornalieri",
      feature_1_desc: "Ora per ora, ogni giornata è disegnata con cura chirurgica.",
      feature_2_title: "Budget trasparente",
      feature_2_desc: "Suddivisione chiara tra trasporti, alloggio, cibo e attività.",
      feature_3_title: "Magia AI",
      feature_3_desc: "Claude Sonnet 4.5 disegna il tuo viaggio in pochi secondi.",
    },
    auth: {
      login_title: "Bentornato",
      register_title: "Crea il tuo account",
      email: "Email",
      password: "Password",
      name: "Nome",
      submit_login: "Accedi",
      submit_register: "Registrati",
      switch_to_register: "Non hai un account? Registrati",
      switch_to_login: "Hai già un account? Accedi",
      forgot_password: "Password dimenticata?",
      forgot_title: "Ripristina la password",
      forgot_desc: "Inserisci la tua email: ti invieremo un codice a 6 cifre per creare una nuova password.",
      forgot_submit: "Invia codice",
      forgot_sending: "Invio in corso...",
      forgot_cancel: "Annulla",
      forgot_success: "Se questa email è registrata, riceverai a breve un codice. Controlla anche la cartella spam.",
      verify_email_sent: "Ti abbiamo inviato un codice via email.",
      reset_overline: "Nuova password",
      reset_title: "Inserisci il codice",
      reset_desc_prefix: "Abbiamo inviato un codice a 6 cifre a",
      reset_code_label: "Codice",
      reset_new_password: "Nuova password",
      reset_submit: "Reimposta password",
      reset_resend: "Non hai ricevuto il codice? Rimandalo",
      reset_success: "Password aggiornata. Bentornato!",
      reset_error_code: "Inserisci il codice a 6 cifre.",
      reset_error_pwd: "La password deve avere almeno 6 caratteri.",
    },
    verify: {
      overline: "Verifica email",
      title: "Un ultimo passo",
      desc_prefix: "Abbiamo inviato un codice a 6 cifre a",
      desc_suffix: "Inseriscilo qui sotto per attivare il tuo account.",
      code_label: "Codice di verifica",
      submit: "Verifica",
      verifying: "Verifica in corso...",
      resend: "Non hai ricevuto il codice? Rimandalo",
      resending: "Invio in corso...",
      resend_wait: "Rinvia tra",
      resent: "Ti abbiamo inviato un nuovo codice.",
      success: "Email verificata. Benvenuto!",
      error_incomplete: "Inserisci tutte e 6 le cifre.",
      back_to_login: "← Torna al login",
      notice_required: "Il tuo account non è ancora verificato. Ti abbiamo appena inviato un nuovo codice.",
    },
    plan: {
      title: "Nuovo viaggio",
      subtitle: "Racconta i dettagli, l'AI cuce l'itinerario.",
      origin: "Luogo di partenza",
      destination: "Destinazione",
      departure: "Data di partenza",
      return: "Data di ritorno",
      people: "Numero di persone",
      includes_title: "Cosa includere nel viaggio",
      include_transport: "Includi trasporti (voli/treni)",
      include_transport_desc: "Se disattivo, l'AI non pianifica voli/treni di andata/ritorno.",
      include_accommodation: "Includi alloggio",
      include_accommodation_desc: "Se disattivo, nessun hotel suggerito e nessun link di prenotazione.",
      budget: "Budget totale",
      budget_section: "Budget & stile del viaggio",
      budget_section_desc: "Scegli uno stile o inserisci una cifra precisa. L'AI adatta hotel, voli e attività.",
      tier_economic: "Economico",
      tier_economic_sub: "Zaino in spalla",
      tier_standard: "Standard",
      tier_standard_sub: "Comfort",
      tier_luxury: "Lusso",
      tier_luxury_sub: "Premium",
      currency: "Valuta",
      preferences: "Preferenze (opzionale)",
      preferences_placeholder: "es. cibo di strada, musei, spiaggia, escursioni...",
      submit: "Genera itinerario",
      generating: "L'AI sta pianificando il tuo viaggio...",
      generating_sub: "Voli, hotel, attività — un attimo di pazienza.",
    },
    dashboard: {
      title: "I tuoi viaggi",
      subtitle: "Ogni destinazione, ogni giornata, sempre a portata di mano.",
      empty_title: "Nessun viaggio ancora.",
      empty_desc: "Crea il tuo primo itinerario in meno di un minuto.",
      new_trip: "Nuovo viaggio",
      people: "persone",
      view: "Apri",
      delete: "Elimina",
    },
    trip: {
      overview: "Panoramica",
      itinerary: "Itinerario",
      day: "Giorno",
      budget: "Budget",
      breakdown: "Suddivisione",
      transport: "Trasporti",
      accommodation: "Alloggio",
      food: "Cibo",
      activities: "Attività",
      total: "Totale",
      per_person: "A persona",
      hotels: "Alloggi suggeriti",
      book_on_booking: "Prenota su Booking.com",
      book_flights: "Cerca voli",
      book_trains: "Cerca treni",
      transport_suggestion: "Trasporto suggerito",
      tips: "Consigli",
      per_night: "a notte",
      back: "Indietro",
      delete_confirm: "Sei sicuro di voler eliminare questo viaggio?",
      delete_title: "Elimina viaggio",
      delete_action: "Elimina",
      cancel: "Annulla",
      edit: "Modifica",
      save: "Salva",
      saving: "Salvataggio...",
      saved: "Modifiche salvate",
      add_day: "Aggiungi giorno",
      remove_day: "Rimuovi giorno",
      add_activity: "Aggiungi attività",
      regenerate_day: "Rigenera giorno",
      regenerate_hint: "Come vuoi rigenerare questo giorno? (opzionale)",
      regenerate_title: "Rigenera il giorno con l'AI",
      regenerating: "Il Genio sta ridisegnando il giorno...",
      export_pdf: "Stampa / PDF",
      download_pdf: "Scarica PDF",
    },
    wishes: {
      title: "Wish Board",
      subtitle: "Fissa i tuoi sogni. Il Genio è pronto a esaudirli.",
      empty_title: "Nessun sogno fissato.",
      empty_desc: "Aggiungi la prima destinazione dei tuoi sogni.",
      add: "Aggiungi sogno",
      destination_placeholder: "Es. Kyoto, Islanda, Marrakech...",
      note_placeholder: "Note (opzionale) — cosa ti attira di questo luogo?",
      evoke: "Evoca il viaggio",
      delete_wish: "Rimuovi",
    },
    feedback: {
      title: "Feedback",
      subtitle: "Un pensiero, un consiglio, un bug: il Genio ascolta.",
      name: "Nome (opzionale)",
      email: "Email (opzionale)",
      rating: "Voto",
      message: "Messaggio",
      message_placeholder: "Cosa vuoi dirci?",
      submit: "Invia",
      submitted: "Grazie! Il tuo feedback è arrivato.",
      recent_title: "I tuoi feedback recenti",
      empty: "Nessun feedback ancora.",
    },
    donations: {
      title: "Offri qualcosa al Genio",
      subtitle: "Se ti sto aiutando a viaggiare meglio, puoi contribuire con un piccolo gesto.",
      coffee: "Offrimi un caffè",
      breakfast: "Offrimi la colazione",
      pizza: "Offrimi una pizza",
      thanks: "Grazie di cuore ✨",
    },
    common: {
      loading: "Caricamento...",
      error: "Si è verificato un errore.",
    },
  },
  en: {
    brand: "Il Genio in Vacanza",
    tagline: "The perfect itinerary, conjured in a heartbeat.",
    nav: {
      plan: "Plan",
      trips: "My trips",
      wishes: "Wishes",
      feedback: "Feedback",
      login: "Sign in",
      register: "Sign up",
      logout: "Log out",
    },
    landing: {
      overline: "AI Travel Atelier",
      title: "Make a wish. Your journey takes shape.",
      subtitle:
        "Tell the Genie your origin, destination, dates, party size and budget — it weaves flights, hotels and experiences into a day-by-day plan.",
      cta: "Conjure my trip",
      cta_login: "I already have an account",
      feature_1_title: "Day-by-day plans",
      feature_1_desc: "Every day mapped hour by hour with coherent activities.",
      feature_2_title: "Transparent budget",
      feature_2_desc: "Clear split across transport, stays, food and activities.",
      feature_3_title: "AI-crafted magic",
      feature_3_desc: "Claude Sonnet 4.5 crafts your journey in seconds.",
    },
    auth: {
      login_title: "Welcome back",
      register_title: "Create your account",
      email: "Email",
      password: "Password",
      name: "Name",
      submit_login: "Sign in",
      submit_register: "Sign up",
      switch_to_register: "No account yet? Sign up",
      switch_to_login: "Already have an account? Sign in",
      forgot_password: "Forgot password?",
      forgot_title: "Reset your password",
      forgot_desc: "Enter your email and we'll send you a 6-digit code to set a new password.",
      forgot_submit: "Send code",
      forgot_sending: "Sending...",
      forgot_cancel: "Cancel",
      forgot_success: "If this email is registered, you'll receive a code shortly. Please also check your spam folder.",
      verify_email_sent: "We just sent you a verification code.",
      reset_overline: "New password",
      reset_title: "Enter the code",
      reset_desc_prefix: "We sent a 6-digit code to",
      reset_code_label: "Code",
      reset_new_password: "New password",
      reset_submit: "Reset password",
      reset_resend: "Didn't get the code? Send again",
      reset_success: "Password updated. Welcome back!",
      reset_error_code: "Enter the 6-digit code.",
      reset_error_pwd: "Password must be at least 6 characters.",
    },
    verify: {
      overline: "Email verification",
      title: "One last step",
      desc_prefix: "We sent a 6-digit code to",
      desc_suffix: "Enter it below to activate your account.",
      code_label: "Verification code",
      submit: "Verify",
      verifying: "Verifying...",
      resend: "Didn't get the code? Send again",
      resending: "Sending...",
      resend_wait: "Resend in",
      resent: "We sent you a new code.",
      success: "Email verified. Welcome!",
      error_incomplete: "Please enter all 6 digits.",
      back_to_login: "← Back to login",
      notice_required: "Your account isn't verified yet. We just sent you a new code.",
    },
    plan: {
      title: "New trip",
      subtitle: "Tell us the details, the AI drafts the plan.",
      origin: "From",
      destination: "To",
      departure: "Departure date",
      return: "Return date",
      people: "Number of travelers",
      includes_title: "What to include in this trip",
      include_transport: "Include transport (flights/trains)",
      include_transport_desc: "When off, the AI won't plan outbound/return transport.",
      include_accommodation: "Include accommodation",
      include_accommodation_desc: "When off, no hotel suggestions and no booking links.",
      budget: "Total budget",
      budget_section: "Budget & travel style",
      budget_section_desc: "Pick a style or enter an exact amount. The AI adjusts hotels, flights and activities.",
      tier_economic: "Budget",
      tier_economic_sub: "Backpacker",
      tier_standard: "Standard",
      tier_standard_sub: "Comfort",
      tier_luxury: "Luxury",
      tier_luxury_sub: "Premium",
      currency: "Currency",
      preferences: "Preferences (optional)",
      preferences_placeholder: "e.g. street food, museums, beach, hikes...",
      submit: "Generate itinerary",
      generating: "The AI is planning your trip...",
      generating_sub: "Flights, hotels, activities — one moment.",
    },
    dashboard: {
      title: "Your trips",
      subtitle: "Every destination, every day, always at hand.",
      empty_title: "No trips yet.",
      empty_desc: "Create your first itinerary in under a minute.",
      new_trip: "New trip",
      people: "travelers",
      view: "Open",
      delete: "Delete",
    },
    trip: {
      overview: "Overview",
      itinerary: "Itinerary",
      day: "Day",
      budget: "Budget",
      breakdown: "Breakdown",
      transport: "Transport",
      accommodation: "Stays",
      food: "Food",
      activities: "Activities",
      total: "Total",
      per_person: "Per person",
      hotels: "Suggested stays",
      book_on_booking: "Book on Booking.com",
      book_flights: "Search flights",
      book_trains: "Search trains",
      transport_suggestion: "Suggested transport",
      tips: "Tips",
      per_night: "per night",
      back: "Back",
      delete_confirm: "Are you sure you want to delete this trip?",
      delete_title: "Delete trip",
      delete_action: "Delete",
      cancel: "Cancel",
      edit: "Edit",
      save: "Save",
      saving: "Saving...",
      saved: "Changes saved",
      add_day: "Add day",
      remove_day: "Remove day",
      add_activity: "Add activity",
      regenerate_day: "Regenerate day",
      regenerate_hint: "How should we regenerate this day? (optional)",
      regenerate_title: "Reimagine this day with AI",
      regenerating: "The Genie is redesigning the day...",
      export_pdf: "Print / PDF",
      download_pdf: "Download PDF",
    },
    wishes: {
      title: "Wish Board",
      subtitle: "Pin your dreams. The Genie stands ready to grant them.",
      empty_title: "No wishes yet.",
      empty_desc: "Add the first destination of your dreams.",
      add: "Add wish",
      destination_placeholder: "e.g. Kyoto, Iceland, Marrakech...",
      note_placeholder: "Note (optional) — what draws you to this place?",
      evoke: "Evoke this trip",
      delete_wish: "Remove",
    },
    feedback: {
      title: "Feedback",
      subtitle: "A thought, a tip, a bug: the Genie is listening.",
      name: "Name (optional)",
      email: "Email (optional)",
      rating: "Rating",
      message: "Message",
      message_placeholder: "What would you like to tell us?",
      submit: "Send",
      submitted: "Thank you! Your feedback landed safely.",
      recent_title: "Your recent feedback",
      empty: "No feedback yet.",
    },
    donations: {
      title: "Treat the Genie",
      subtitle: "If I'm helping you travel better, you can support with a small gesture.",
      coffee: "Buy me a coffee",
      breakfast: "Buy me breakfast",
      pizza: "Buy me a pizza",
      thanks: "Thanks a lot ✨",
    },
    common: {
      loading: "Loading...",
      error: "Something went wrong.",
    },
  },
};
